export default __webpack_public_path__ + "static/media/rice.d5b2fc34.pdf";